import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    Typography,
} from '@material-ui/core'
import { ClauseTitle, TagsHighlight } from '../Atoms'

const useStyles = makeStyles(theme => ({
    root: {
        width: `100%`,
        cursor: 'pointer',
        boxShadow: theme.customShadows.primary.dark[0],
        margin: 1,
        '&:hover': {
            boxShadow: theme.customShadows.primary.dark[1],
        },
        backgroundColor: "rgb(0, 118, 145,0.05)",
    },
    bold: {
        fontWeight: theme.typography.fontWeightBold
    },
    cardHeader: {
        paddingBottom: theme.spacing(0.5),
    },
}))

const ModelCard = ({ model, handleClickCard }) => {
    const classes = useStyles()
    const { t, i18n } = useTranslation()

    const safeClickCard = model => {
        if (window.getSelection().toString() === '') {
            handleClickCard()
        }
    }

    return (
        <Card
            raised
            classes={{ root: classes.root }}
            onClick={() => safeClickCard(model)}
        >
            <CardHeader
                className={classes.cardHeader}
                title={
                    <Grid container justifyContent="space-between" alignItems="center">
                        <ClauseTitle variant="body1" title={
                            model[`title_${i18n.language}`]
                        } />
                    </Grid>
                }
                subheader={
                    <TagsHighlight tags={[...model[`tags_${i18n.language}`]]} tags_highlight={model.highlight && model.highlight.tags_highlight} />
                }
            />
            <CardContent style={{ paddingTop: 0 }}>
                <Grid container justifyContent='space-between'>
                    <Typography>{t('links.providedBy')}</Typography>
                    <img style={{ width: 80 }} alt='Fednot logo' src='https://portal.fednot.be/themes/custom/fednot/logo.svg' />
                </Grid>
            </CardContent>
        </Card>
    )
}

export default ModelCard